var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action, makeObservable } from 'mobx';
import * as _ from "lodash";
import enLocale from 'date-fns/locale/en-US';
import csLocale from 'date-fns/locale/cs';
import deLocale from 'date-fns/locale/de';
import grLocale from 'date-fns/locale/el';
import esLocale from 'date-fns/locale/es';
import frLocale from 'date-fns/locale/fr';
import huLocale from 'date-fns/locale/hu';
import itLocale from 'date-fns/locale/it';
import koLocale from 'date-fns/locale/ko';
import nlLocale from 'date-fns/locale/nl';
import plLocale from 'date-fns/locale/pl';
import ptLocale from 'date-fns/locale/pt';
import skLocale from 'date-fns/locale/sk';
import hrLocale from 'date-fns/locale/hr';
var localeMap = {
    en: enLocale,
    cs: csLocale,
    de: deLocale,
    el: grLocale,
    es: esLocale,
    fr: frLocale,
    hu: huLocale,
    hr: hrLocale,
    it: itLocale,
    ko: koLocale,
    nl: nlLocale,
    pl: plLocale,
    pt: ptLocale,
    sk: skLocale
};
var translations = {
    'en': observable({
        'Field.Owner': 'Owner',
        'Field.Brand': 'Brand',
        'Field.Model': 'Model',
        'Field.Mileage': 'Mileage',
        'Field.LicensePlateNumber': 'License plate number',
        'Field.CarSerialNumber': 'Car serial number',
        'Field.InsurancePolicyNumber': 'Insurance policy number',
        'Field.ExternalID': 'External ID',
        'Claims.Organization': 'Organization',
        'Claims.Expert': 'Expert',
        'Claims.ExternalID': 'External ID',
        'Claims.Created': 'Created',
        'Claims.LastChange': 'Modified',
        'Claims.CallDuration': 'Call duration',
        'Claims.Photos': 'Files',
        'Claims.Client': 'Client',
        'Claims.ClaimInfo': 'Claim info',
        'Claims.Rating': 'Rating',
        'Claims.Actions': 'Actions',
        'Claims.Today': 'Today',
        'Claims.Yesterday': 'Yesterday',
        'Claims.PageSize': 'Page size',
        'Claims.Search': 'Search',
        'Claims.FromDate': 'From date',
        'Claims.ToDate': 'To date',
        'Claims.Country': 'Country',
        'Claims.CaseType': 'Case Type',
        'Claims.Text': 'Text',
        'Claims.Count': 'case(s) found',
        'Claims.ThisWeek': 'This week',
        'Claims.ThisMonth': 'This month',
        'Claims.PreviousWeek': 'Previous week',
        'Claims.PreviousMonth': 'Previous month',
        'Claims.Criteria': 'Criteria',
        'Claims.CreatedDate': 'Created date',
        'Claims.ModifiedDate': 'Modified date',
        'Claims.FilterAll': 'All',
        'AddressBook.FullName': 'Full Name',
        'AddressBook.Organization': 'Organization',
        'AddressBook.Address': 'Address',
        'AddressBook.CaseTypes': 'Case Types',
        'AddressBook.CreatedBy': 'Created By',
        'AddressBook.Actions': 'Actions',
        'AddressBook.CreateNew': 'Add new address',
        'AddressBookEdit.Organization': 'Organization',
        'AddressBookEdit.FirstName': 'First Name',
        'AddressBookEdit.LastName': 'Last Name',
        'AddressBookEdit.PhoneNumber': 'Phone number',
        'AddressBookEdit.Email': 'Email',
        'AddressBookEdit.Description': 'Description',
        'AddressBookEdit.Street': 'Street',
        'AddressBookEdit.HouseNr': 'House Nr',
        'AddressBookEdit.City': 'City',
        'AddressBookEdit.PostalCode': 'Postal Code',
        'AddressBookEdit.Country': 'Country',
        'AddressBookEdit.CaseTypes': 'Case Types',
        'AddressBookEdit.AdditionalInfo': 'Additional Info',
        'AddressBookEdit.Visibility': 'Visibility',
        'AddressBookEdit.Visibility.Owner': 'Should be available only for me',
        'AddressBookEdit.Visibility.Organization': 'Should be available on organization',
        'AddressBookEdit.Save': 'Save',
        'AddressBookEdit.Cancel': 'Cancel',
        'AddressBookEdit.Title': 'Address Edit',
        'Settings.Ticket.Option.Header': 'Ticket settings',
        'Settings.Ticket.Option.Field.Expires': 'Ticket expires',
        'Settings.Ticket.Option.Field.Reused': 'Ticket can be reused',
        'Settings.Ticket.SmsTemplate.Header': 'SMS template',
        'Settings.Ticket.SmsTemplate.Field.Template': 'SMS template',
        'Settings.Ticket.SmsTemplate.Field.AppendLinkButton': 'Append Link',
        'Settings.Ticket.EmailTemplate.Header': 'Email template',
        'Settings.Ticket.EmailTemplate.ReplyTo': 'Reply to',
        'Settings.Ticket.EmailTemplate.Field.Subject': 'Subject',
        'Settings.Ticket.EmailTemplate.Error.EmailNotValid': 'Email address is not valid',
        'OrganizationGroups.CreateNew': 'Create New',
        'OrganizationGroups.Name': 'Name',
        'OrganizationGroups.CaseTypes': 'Case Types',
        'OrganizationGroups.Users': 'Users',
        'OrganizationGroups.Actions': 'Actions',
        'OrganizationGroups.Save': 'Save',
        'OrganizationGroups.Cancel': 'Cancel',
    }),
    'de': observable({
        'Field.Owner': 'Besitzer',
        'Field.Brand': 'Marke',
        'Field.Model': 'Modell',
        'Field.Mileage': 'Kilometerstand',
        'Field.LicensePlateNumber': 'Kennzeichen',
        'Field.CarSerialNumber': 'Fahrgestellnummer',
        'Field.InsurancePolicyNumber': 'Polizzennummer',
        'Field.ExternalID': 'Auftragsnummer',
        'Claims.Organization': 'Organisation',
        'Claims.Expert': 'Sachverständiger',
        'Claims.ExternalID': 'Externe Referenz',
        'Claims.Created': 'Erstellt',
        'Claims.LastChange': 'letzte Bearbeitung',
        'Claims.CallDuration': 'Gesprächsdauer',
        'Claims.Photos': 'Dokumente',
        'Claims.Client': 'Kunde',
        'Claims.ClaimInfo': 'Fallinfo',
        'Claims.Rating': 'Bewertung',
        'Claims.Actions': 'Aktionen',
        'Claims.Today': 'Heute',
        'Claims.Yesterday': 'Gestern',
        'Claims.PageSize': 'Seitengröße',
        'Claims.Search': 'Suche',
        'Claims.FromDate': 'von Datum',
        'Claims.ToDate': 'bis Datum',
        'Claims.Country': 'Land',
        'Claims.CaseType': 'Art des Falls',
        'Claims.Text': 'Text',
        'Claims.Count': 'gefundene Fälle',
        'Claims.ThisWeek': 'diese Woche',
        'Claims.ThisMonth': 'dieser Monat',
        'Claims.PreviousWeek': 'letzte Woche',
        'Claims.PreviousMonth': 'vorheriger Monat',
        'Claims.Criteria': 'Kriterien',
        'Claims.CreatedDate': 'Erstellt',
        'Claims.ModifiedDate': 'Bearbeitung',
        'Claims.FilterAll': 'Alle',
        'AddressBook.FullName': 'Name',
        'AddressBook.Organization': 'Organisation',
        'AddressBook.Address': 'Adresse',
        'AddressBook.CaseTypes': 'Arten des Falls',
        'AddressBook.CreatedBy': 'Erstellt von',
        'AddressBook.Actions': 'Aktionen',
        'AddressBook.CreateNew': 'Neue Adresse hinzufügen',
        'AddressBookEdit.Organization': 'Organisation',
        'AddressBookEdit.FirstName': 'Vorname',
        'AddressBookEdit.LastName': 'Last Name',
        'AddressBookEdit.PhoneNumber': 'Telefonnummer',
        'AddressBookEdit.Email': 'Email',
        'AddressBookEdit.Description': 'Beschreibung',
        'AddressBookEdit.Street': 'Straße',
        'AddressBookEdit.HouseNr': 'Haus Nr',
        'AddressBookEdit.City': 'Ort',
        'AddressBookEdit.PostalCode': 'PLZ',
        'AddressBookEdit.Country': 'Land',
        'AddressBookEdit.CaseTypes': 'Arten des Falls',
        'AddressBookEdit.AdditionalInfo': 'Zusätzliche Information',
        'AddressBookEdit.Visibility': 'Sichtweite',
        'AddressBookEdit.Visibility.Owner': 'Sollte nur für mich verfügbar sein',
        'AddressBookEdit.Visibility.Organization': 'Sollte bei der Organisation verfügbar sein',
        'AddressBookEdit.Save': 'Speichern',
        'AddressBookEdit.Cancel': 'Schließen',
        'AddressBookEdit.Title': 'Adresse Bearbeiten',
        'Settings.Ticket.Option.Header': 'Ticket Einstellungen',
        'Settings.Ticket.Option.Field.Expires': 'Ticket läuft ab',
        'Settings.Ticket.Option.Field.Reused': 'Ticket kann wiederverwendet werden',
        'Settings.Ticket.SmsTemplate.Header': 'SMS-Vorlage',
        'Settings.Ticket.SmsTemplate.Field.Template': 'SMS-Vorlage',
        'Settings.Ticket.SmsTemplate.Field.AppendLinkButton': 'Link anhängen',
        'Settings.Ticket.EmailTemplate.Header': 'E-Mail-Vorlage',
        'Settings.Ticket.EmailTemplate.ReplyTo': 'Antworten an',
        'Settings.Ticket.EmailTemplate.Field.Subject': 'Betreff',
        'Settings.Ticket.EmailTemplate.Error.EmailNotValid': 'E-Mail-Adresse ist ungültig',
        'OrganizationGroups.CreateNew': 'Neue erstellen',
        'OrganizationGroups.Name': 'Name',
        'OrganizationGroups.CaseTypes': 'Arten des Falls',
        'OrganizationGroups.Users': 'Benutzer',
        'OrganizationGroups.Actions': 'Aktionen',
        'OrganizationGroups.Save': 'Speichern',
        'OrganizationGroups.Cancel': 'Stornieren',
    }),
    'cs': observable({
        'Field.Owner': 'Majitel',
        'Field.Brand': 'Značka',
        'Field.Model': 'Model',
        'Field.Mileage': 'Stav km',
        'Field.LicensePlateNumber': 'SPZ',
        'Field.CarSerialNumber': 'Číslo podvozku',
        'Field.InsurancePolicyNumber': 'Číslo pojistky',
        'Field.ExternalID': 'Číslo zakázky',
        'Claims.Organization': 'Organization',
        'Claims.Expert': 'Expert',
        'Claims.ExternalID': 'External ID',
        'Claims.Created': 'Vytvořeno',
        'Claims.LastChange': 'Modified',
        'Claims.CallDuration': 'Call duration',
        'Claims.Photos': 'Photos',
        'Claims.Client': 'Client',
        'Claims.ClaimInfo': 'Claim info',
        'Claims.Rating': 'Rating',
        'Claims.Actions': 'Actions',
        'Claims.Today': 'Today',
        'Claims.Yesterday': 'Yesterday',
        'Claims.PageSize': 'Page size',
        'Claims.Search': 'Search',
        'Claims.FromDate': 'From date',
        'Claims.ToDate': 'To date',
        'Claims.Country': 'Country',
        'Claims.CaseType': 'Case Type',
        'Claims.Text': 'Text',
        'Claims.Count': 'case(s) found',
        'Claims.ThisWeek': 'This week',
        'Claims.ThisMonth': 'This month',
        'Claims.PreviousWeek': 'Previous week',
        'Claims.PreviousMonth': 'Previous month',
        'Claims.Criteria': 'Criteria',
        'Claims.CreatedDate': 'Created date',
        'Claims.ModifiedDate': 'Modified date',
        'Claims.FilterAll': 'Vše',
        'AddressBook.FullName': 'Full Name',
        'AddressBook.Organization': 'Organization',
        'AddressBook.Address': 'Address',
        'AddressBook.CaseTypes': 'Case Types',
        'AddressBook.CreatedBy': 'Created By',
        'AddressBook.Actions': 'Actions',
        'AddressBook.CreateNew': 'Add new address',
        'AddressBookEdit.Organization': 'Organization',
        'AddressBookEdit.FirstName': 'First Name',
        'AddressBookEdit.LastName': 'Last Name',
        'AddressBookEdit.PhoneNumber': 'Phone number',
        'AddressBookEdit.Email': 'Email',
        'AddressBookEdit.Description': 'Description',
        'AddressBookEdit.Street': 'Street',
        'AddressBookEdit.HouseNr': 'House Nr',
        'AddressBookEdit.City': 'City',
        'AddressBookEdit.PostalCode': 'Postal Code',
        'AddressBookEdit.Country': 'Country',
        'AddressBookEdit.CaseTypes': 'Case Types',
        'AddressBookEdit.AdditionalInfo': 'Additional Info',
        'AddressBookEdit.Visibility': 'Visibility',
        'AddressBookEdit.Visibility.Owner': 'Should be available only for me',
        'AddressBookEdit.Visibility.Organization': 'Should be available on organization',
        'AddressBookEdit.Save': 'Save',
        'AddressBookEdit.Cancel': 'Cancel',
        'AddressBookEdit.Title': 'Address',
        'Settings.Ticket.Option.Header': 'Ticket settings',
        'Settings.Ticket.Option.Field.Expires': 'Ticket expires',
        'Settings.Ticket.Option.Field.Reused': 'Ticket can be reused',
        'Settings.Ticket.SmsTemplate.Header': 'SMS template',
        'Settings.Ticket.SmsTemplate.Field.Template': 'SMS template',
        'Settings.Ticket.SmsTemplate.Field.AppendLinkButton': 'Append Link',
        'Settings.Ticket.EmailTemplate.Header': 'Email template',
        'Settings.Ticket.EmailTemplate.ReplyTo': 'Reply to',
        'Settings.Ticket.EmailTemplate.Field.Subject': 'Subject',
        'Settings.Ticket.EmailTemplate.Error.EmailNotValid': 'Email address is not valid',
        'OrganizationGroups.CreateNew': 'Vytvořit nový',
        'OrganizationGroups.Name': 'Jméno',
        'OrganizationGroups.CaseTypes': 'Typy případů',
        'OrganizationGroups.Users': 'Uživatelé',
        'OrganizationGroups.Actions': 'Akce',
        'OrganizationGroups.Save': 'Uložit',
        'OrganizationGroups.Cancel': 'Zrušit'
    }),
    'sk': observable({
        'Field.Owner': 'Majitel',
        'Field.Brand': 'Značka',
        'Field.Model': 'Model',
        'Field.Mileage': 'Stav km',
        'Field.LicensePlateNumber': 'EČ vozidla',
        'Field.CarSerialNumber': 'Číslo podvozku',
        'Field.InsurancePolicyNumber': 'Číslo poistky',
        'Field.ExternalID': 'Číslo zákazky',
        'Claims.Organization': 'Organization',
        'Claims.Expert': 'Expert',
        'Claims.ExternalID': 'External ID',
        'Claims.Created': 'Vytvorené',
        'Claims.LastChange': 'Modified',
        'Claims.CallDuration': 'Call duration',
        'Claims.Photos': 'Photos',
        'Claims.Client': 'Client',
        'Claims.ClaimInfo': 'Claim info',
        'Claims.Rating': 'Rating',
        'Claims.Actions': 'Actions',
        'Claims.Today': 'Today',
        'Claims.Yesterday': 'Yesterday',
        'Claims.PageSize': 'Page size',
        'Claims.Search': 'Search',
        'Claims.FromDate': 'From date',
        'Claims.ToDate': 'To date',
        'Claims.Country': 'Country',
        'Claims.CaseType': 'Case Type',
        'Claims.Text': 'Text',
        'Claims.Count': 'case(s) found',
        'Claims.ThisWeek': 'This week',
        'Claims.ThisMonth': 'This month',
        'Claims.PreviousWeek': 'Previous week',
        'Claims.PreviousMonth': 'Previous month',
        'Claims.Criteria': 'Criteria',
        'Claims.CreatedDate': 'Created date',
        'Claims.ModifiedDate': 'Modified date',
        'Claims.FilterAll': 'Všetky',
        'AddressBook.FullName': 'Full Name',
        'AddressBook.Organization': 'Organization',
        'AddressBook.Address': 'Address',
        'AddressBook.CaseTypes': 'Case Types',
        'AddressBook.CreatedBy': 'Created By',
        'AddressBook.Actions': 'Actions',
        'AddressBook.CreateNew': 'Add new address',
        'AddressBookEdit.Organization': 'Organization',
        'AddressBookEdit.FirstName': 'First Name',
        'AddressBookEdit.LastName': 'Last Name',
        'AddressBookEdit.PhoneNumber': 'Phone number',
        'AddressBookEdit.Email': 'Email',
        'AddressBookEdit.Description': 'Description',
        'AddressBookEdit.Street': 'Street',
        'AddressBookEdit.HouseNr': 'House Nr',
        'AddressBookEdit.City': 'City',
        'AddressBookEdit.PostalCode': 'Postal Code',
        'AddressBookEdit.Country': 'Country',
        'AddressBookEdit.CaseTypes': 'Case Types',
        'AddressBookEdit.AdditionalInfo': 'Additional Info',
        'AddressBookEdit.Visibility': 'Visibility',
        'AddressBookEdit.Visibility.Owner': 'Should be available only for me',
        'AddressBookEdit.Visibility.Organization': 'Should be available on organization',
        'AddressBookEdit.Save': 'Save',
        'AddressBookEdit.Cancel': 'Cancel',
        'AddressBookEdit.Title': 'Address',
        'Settings.Ticket.Option.Header': 'Ticket settings',
        'Settings.Ticket.Option.Field.Expires': 'Ticket expires',
        'Settings.Ticket.Option.Field.Reused': 'Ticket can be reused',
        'Settings.Ticket.SmsTemplate.Header': 'SMS template',
        'Settings.Ticket.SmsTemplate.Field.Template': 'SMS template',
        'Settings.Ticket.SmsTemplate.Field.AppendLinkButton': 'Append Link',
        'Settings.Ticket.EmailTemplate.Header': 'Email template',
        'Settings.Ticket.EmailTemplate.ReplyTo': 'Reply to',
        'Settings.Ticket.EmailTemplate.Field.Subject': 'Subject',
        'Settings.Ticket.EmailTemplate.Error.EmailNotValid': 'Email address is not valid',
        'OrganizationGroups.CreateNew': 'Vytvoriť nový',
        'OrganizationGroups.Name': 'Názov',
        'OrganizationGroups.CaseTypes': 'Typy prípadov',
        'OrganizationGroups.Users': 'Používatelia',
        'OrganizationGroups.Actions': 'Akcie',
        'OrganizationGroups.Save': 'Uložiť',
        'OrganizationGroups.Cancel': 'Zrušiť'
    }),
    'el': observable({
        'Field.Owner': 'Ονομασία υπόθεσης',
        'Field.Brand': 'Οχημα',
        'Field.Model': 'Μοντέλο',
        'Field.Mileage': 'KM',
        'Field.LicensePlateNumber': 'Αριθμός πινακίδας',
        'Field.CarSerialNumber': 'Σειριακός Αριθμός',
        'Field.InsurancePolicyNumber': 'Αριθμός ασφαλιστηρίου',
        'Field.ExternalID': 'Εξωτερικός αριθμός',
        'Claims.Organization': 'Οργανισμός',
        'Claims.Expert': 'Πραγματογνώμονας',
        'Claims.ExternalID': 'Εξωτερικό ID',
        'Claims.Created': 'Δημιουργήθηκε',
        'Claims.LastChange': 'Τελευταία Αλλαγή',
        'Claims.CallDuration': 'Διάρκεια Κλήσης',
        'Claims.Photos': 'Φωτογραφίες',
        'Claims.Client': 'Πελάτης',
        'Claims.ClaimInfo': 'Στοιχεία Φακέλου',
        'Claims.Rating': 'Aξιολόγηση',
        'Claims.Actions': 'Δράσεις',
        'Claims.Today': 'Σήμερα',
        'Claims.Yesterday': 'Εχθές',
        'Claims.PageSize': 'Μέγεθος Σελίδας',
        'Claims.Search': 'Αναζήτηση',
        'Claims.FromDate': 'Από την ημέρα',
        'Claims.ToDate': 'Μέχρι την ημέρα',
        'Claims.Country': 'Χώρα',
        'Claims.CaseType': 'Τύποι Περιπτώσεων',
        'Claims.Text': 'Κείμενο',
        'Claims.Count': 'Περιπτώσεις που Βρέθηκαν',
        'Claims.ThisWeek': 'Αυτη την Εβδομάδα',
        'Claims.ThisMonth': 'Αυτο το Μήνας',
        'Claims.PreviousWeek': 'Προηγούμενη Εβδομάδα',
        'Claims.PreviousMonth': 'Προηγούμενο Μήνα',
        'Claims.Criteria': 'Κριτήρια',
        'Claims.CreatedDate': 'Δημιουργήθηκε',
        'Claims.ModifiedDate': 'Τελευταία Αλλαγή',
        'Claims.FilterAll': 'Ολα',
        'AddressBook.FullName': 'Πλήρες όνομα',
        'AddressBook.Organization': 'Οργανισμός',
        'AddressBook.Address': 'Διεύθυνση',
        'AddressBook.CaseTypes': 'Τύποι υπόθεσης',
        'AddressBook.CreatedBy': 'Δημιουργήθηκε από',
        'AddressBook.Actions': 'Δράσεις',
        'AddressBook.CreateNew': 'Add new address',
        'AddressBookEdit.Organization': 'Οργανισμός',
        'AddressBookEdit.FirstName': 'Ονομα',
        'AddressBookEdit.LastName': 'Επίθετο',
        'AddressBookEdit.PhoneNumber': 'Τηλεφωνικό νούμερο',
        'AddressBookEdit.Email': 'Email',
        'AddressBookEdit.Description': 'Περιγραφή',
        'AddressBookEdit.Street': 'Δρόμος',
        'AddressBookEdit.HouseNr': 'Σπίτι Nr',
        'AddressBookEdit.City': 'Πόλη',
        'AddressBookEdit.PostalCode': 'Ταχυδρομικός Κώδικας',
        'AddressBookEdit.Country': 'Χώρα',
        'AddressBookEdit.CaseTypes': 'Τύποι υπόθεσης',
        'AddressBookEdit.AdditionalInfo': 'Πρόσθετες πληροφορίες',
        'AddressBookEdit.Visibility': 'Ορατότητα',
        'AddressBookEdit.Visibility.Owner': 'Θα πρέπει να είναι διαθέσιμο μόνο για μένα',
        'AddressBookEdit.Visibility.Organization': 'Θα πρέπει να είναι διαθέσιμο στον οργανισμό',
        'AddressBookEdit.Save': 'Αποθηκεύσετε',
        'AddressBookEdit.Cancel': 'Ματαίωση',
        'AddressBookEdit.Title': 'Επεξεργασία διεύθυνσης',
        'Settings.Ticket.Option.Header': 'Ticket settings',
        'Settings.Ticket.Option.Field.Expires': 'Ticket expires',
        'Settings.Ticket.Option.Field.Reused': 'Ticket can be reused',
        'Settings.Ticket.SmsTemplate.Header': 'SMS template',
        'Settings.Ticket.SmsTemplate.Field.Template': 'SMS template',
        'Settings.Ticket.SmsTemplate.Field.AppendLinkButton': 'Append Link',
        'Settings.Ticket.EmailTemplate.Header': 'Email template',
        'Settings.Ticket.EmailTemplate.ReplyTo': 'Reply to',
        'Settings.Ticket.EmailTemplate.Field.Subject': 'Subject',
        'Settings.Ticket.EmailTemplate.Error.EmailNotValid': 'Email address is not valid',
        'OrganizationGroups.CreateNew': 'Δημιουργία νέου',
        'OrganizationGroups.Name': 'Ονομα',
        'OrganizationGroups.CaseTypes': 'Τύποι υπόθεσης',
        'OrganizationGroups.Users': 'Χρήστες',
        'OrganizationGroups.Actions': 'Ενέργειες',
        'OrganizationGroups.Save': 'Αποθήκευση',
        'OrganizationGroups.Cancel': 'Ακύρωση'
    }),
    'pl': observable({
        'Field.Owner': 'Sprawa',
        'Field.Brand': 'Marka',
        'Field.Model': 'Model',
        'Field.Mileage': 'Przebieg',
        'Field.LicensePlateNumber': 'Nr rejestracyjny',
        'Field.CarSerialNumber': 'VIN',
        'Field.InsurancePolicyNumber': 'Numer polisy',
        'Field.ExternalID': 'Numer zlecenia',
        'Claims.Organization': 'Organizacja',
        'Claims.Expert': 'Specjalista',
        'Claims.ExternalID': 'Numer zlecenia',
        'Claims.Created': 'Utworzony',
        'Claims.LastChange': 'Ostatnia zmiana',
        'Claims.CallDuration': 'Długość rozmowy',
        'Claims.Photos': 'Zdjęcia',
        'Claims.Client': 'Klient',
        'Claims.ClaimInfo': 'Informacja o sprawie',
        'Claims.Rating': 'Ocena',
        'Claims.Actions': 'Działania',
        'Claims.Today': 'Dzisiaj',
        'Claims.Yesterday': 'Wczoraj',
        'Claims.PageSize': 'Rozmiar strony',
        'Claims.Search': 'Szukaj',
        'Claims.FromDate': 'Od daty',
        'Claims.ToDate': 'Do daty',
        'Claims.Country': 'Kraj',
        'Claims.CaseType': 'Typ sprawy',
        'Claims.Text': 'Tekst',
        'Claims.Count': 'spraw znaleziono',
        'Claims.ThisWeek': 'W tym tygodniu',
        'Claims.ThisMonth': 'W tym miesiącu',
        'Claims.PreviousWeek': 'Poprzedni tydzień',
        'Claims.PreviousMonth': 'Poprzedni miesiąc',
        'Claims.Criteria': 'Kryteria',
        'Claims.CreatedDate': 'Utworzony',
        'Claims.ModifiedDate': 'Ostatnia zmiana',
        'Claims.FilterAll': 'Wszystko',
        'AddressBook.FullName': 'Nazwisko',
        'AddressBook.Organization': 'Organizacja',
        'AddressBook.Address': 'Adres',
        'AddressBook.CaseTypes': 'Typy sprawy',
        'AddressBook.CreatedBy': 'Stworzone przez',
        'AddressBook.Actions': 'Działania',
        'AddressBook.CreateNew': 'Dodaj nowy adres',
        'AddressBookEdit.Organization': 'Organizacja',
        'AddressBookEdit.FirstName': 'Imię',
        'AddressBookEdit.LastName': 'Nazwisko',
        'AddressBookEdit.PhoneNumber': 'Nr telefonu',
        'AddressBookEdit.Email': 'Email',
        'AddressBookEdit.Description': 'Opisanie',
        'AddressBookEdit.Street': 'Ulica',
        'AddressBookEdit.HouseNr': 'Nr domu',
        'AddressBookEdit.City': 'Miasto',
        'AddressBookEdit.PostalCode': 'Kod pocztowy',
        'AddressBookEdit.Country': 'Państwo',
        'AddressBookEdit.CaseTypes': 'Typy sprawy',
        'AddressBookEdit.AdditionalInfo': 'Dodatkowa informacja',
        'AddressBookEdit.Visibility': 'Dostępność',
        'AddressBookEdit.Visibility.Owner': 'Adres powinien być dostępny tylko dla mnie',
        'AddressBookEdit.Visibility.Organization': 'Adres powinien być dostępny dla organizacji',
        'AddressBookEdit.Save': 'Zachowaj',
        'AddressBookEdit.Cancel': 'Anuluj',
        'AddressBookEdit.Title': 'Adres',
        'Settings.Ticket.Option.Header': 'Opcje dot. linka',
        'Settings.Ticket.Option.Field.Expires': 'Wygaśnięcie linka',
        'Settings.Ticket.Option.Field.Reused': 'Link może być ponownie wykorzystany',
        'Settings.Ticket.SmsTemplate.Header': 'SMS szablon',
        'Settings.Ticket.SmsTemplate.Field.Template': 'SMS szablon',
        'Settings.Ticket.SmsTemplate.Field.AppendLinkButton': 'Dołącz link',
        'Settings.Ticket.EmailTemplate.Header': 'Email szablon',
        'Settings.Ticket.EmailTemplate.ReplyTo': 'Odpowiedź do',
        'Settings.Ticket.EmailTemplate.Field.Subject': 'Temat',
        'Settings.Ticket.EmailTemplate.Error.EmailNotValid': 'Adres e-mail jest nieprawidłowy',
        'OrganizationGroups.CreateNew': 'Utwórz',
        'OrganizationGroups.Name': 'Nazwa',
        'OrganizationGroups.CaseTypes': 'Typy sprawy',
        'OrganizationGroups.Users': 'Użytkownicy',
        'OrganizationGroups.Actions': 'Działania',
        'OrganizationGroups.Save': 'Zapisz',
        'OrganizationGroups.Cancel': 'Anuluj'
    }),
    'hu': observable({
        'Field.Owner': 'Tulajdonos neve',
        'Field.Brand': 'Gyártmány',
        'Field.Model': 'Típus',
        'Field.Mileage': 'Futástelj.',
        'Field.LicensePlateNumber': 'Rendszám',
        'Field.CarSerialNumber': 'Alvázszám',
        'Field.InsurancePolicyNumber': 'Kötvényszám',
        'Field.ExternalID': 'Megbízási szám',
        'Claims.Organization': 'Szervezet',
        'Claims.Expert': 'Szakértő',
        'Claims.ExternalID': 'Külső azonosító',
        'Claims.Created': 'Létrehozva',
        'Claims.LastChange': 'Utolsó módosítás',
        'Claims.CallDuration': 'Hívás időtartama',
        'Claims.Photos': 'Fényképek',
        'Claims.Client': 'Ügyfél',
        'Claims.ClaimInfo': 'Káreset információ',
        'Claims.Rating': 'Értékelés',
        'Claims.Actions': 'Műveletek',
        'Claims.Today': 'Mai nap',
        'Claims.Yesterday': 'Tegnap',
        'Claims.PageSize': 'Oldal mérete',
        'Claims.Search': 'Keresés',
        'Claims.FromDate': 'Dátumtól',
        'Claims.ToDate': 'Dátumig',
        'Claims.Country': 'Ország',
        'Claims.CaseType': 'Ügy típusa',
        'Claims.Text': 'Szöveg',
        'Claims.Count': 'találatok száma',
        'Claims.ThisWeek': 'Ezen a héten',
        'Claims.ThisMonth': 'Ebben a hónapban',
        'Claims.PreviousWeek': 'Előző hét',
        'Claims.PreviousMonth': 'Előző hónap',
        'Claims.Criteria': 'Kritériumok',
        'Claims.CreatedDate': 'Létrehozva',
        'Claims.ModifiedDate': 'Utolsó módosítás',
        'Claims.FilterAll': 'Összes',
        'AddressBook.FullName': 'Teljes név',
        'AddressBook.Organization': 'Szervezet',
        'AddressBook.Address': 'Cím',
        'AddressBook.CaseTypes': 'Ügy típusa',
        'AddressBook.CreatedBy': 'Készítette',
        'AddressBook.Actions': 'Műveletek',
        'AddressBook.CreateNew': 'Add new address',
        'AddressBookEdit.Organization': 'Organization',
        'AddressBookEdit.FirstName': 'First Name',
        'AddressBookEdit.LastName': 'Last Name',
        'AddressBookEdit.PhoneNumber': 'Phone number',
        'AddressBookEdit.Email': 'Email',
        'AddressBookEdit.Description': 'Description',
        'AddressBookEdit.Street': 'Street',
        'AddressBookEdit.HouseNr': 'House Nr',
        'AddressBookEdit.City': 'City',
        'AddressBookEdit.PostalCode': 'Postal Code',
        'AddressBookEdit.Country': 'Country',
        'AddressBookEdit.CaseTypes': 'Case Types',
        'AddressBookEdit.AdditionalInfo': 'Additional Info',
        'AddressBookEdit.Visibility': 'Visibility',
        'AddressBookEdit.Visibility.Owner': 'Should be available only for me',
        'AddressBookEdit.Visibility.Organization': 'Should be available on organization',
        'AddressBookEdit.Save': 'Save',
        'AddressBookEdit.Cancel': 'Cancel',
        'AddressBookEdit.Title': 'Address',
        'Settings.Ticket.Option.Header': 'Ticket settings',
        'Settings.Ticket.Option.Field.Expires': 'Ticket expires',
        'Settings.Ticket.Option.Field.Reused': 'Ticket can be reused',
        'Settings.Ticket.SmsTemplate.Header': 'SMS template',
        'Settings.Ticket.SmsTemplate.Field.Template': 'SMS template',
        'Settings.Ticket.SmsTemplate.Field.AppendLinkButton': 'Append Link',
        'Settings.Ticket.EmailTemplate.Header': 'Email template',
        'Settings.Ticket.EmailTemplate.ReplyTo': 'Reply to',
        'Settings.Ticket.EmailTemplate.Field.Subject': 'Subject',
        'Settings.Ticket.EmailTemplate.Error.EmailNotValid': 'Email address is not valid',
        'OrganizationGroups.CreateNew': 'Create New',
        'OrganizationGroups.Name': 'Name',
        'OrganizationGroups.CaseTypes': 'Case Types',
        'OrganizationGroups.Users': 'Users',
        'OrganizationGroups.Actions': 'Actions',
        'OrganizationGroups.Save': 'Save',
        'OrganizationGroups.Cancel': 'Cancel',
    }),
    'hr': observable({
        'Field.Owner': 'Vlasnik',
        'Field.Brand': 'Marka',
        'Field.Model': 'Model',
        'Field.Mileage': 'Kilometraža',
        'Field.LicensePlateNumber': 'Broj registarske pločice',
        'Field.CarSerialNumber': 'Serijski broj automobila',
        'Field.InsurancePolicyNumber': 'Broj police osiguranja',
        'Field.ExternalID': 'Vanjski ID',
        'Claims.Organization': 'Organizacija',
        'Claims.Expert': 'Stručnjak',
        'Claims.ExternalID': 'Vanjski ID',
        'Claims.Created': 'Kreiran',
        'Claims.LastChange': 'Zadnja promjena',
        'Claims.CallDuration': 'Trajanje poziva',
        'Claims.Photos': 'Fotografije',
        'Claims.Client': 'Klijent',
        'Claims.ClaimInfo': 'Informacije o zahtjevu',
        'Claims.Rating': 'Ocjena',
        'Claims.Actions': 'Akcije',
        'Claims.Today': 'Danas',
        'Claims.Yesterday': 'Jučer',
        'Claims.PageSize': 'Veličina stranice',
        'Claims.Search': 'Pretraživanje',
        'Claims.FromDate': 'Od datuma',
        'Claims.ToDate': 'Do datuma',
        'Claims.Country': 'Zemlja',
        'Claims.CaseType': 'Vrsta predmeta',
        'Claims.Text': 'Tekstualna poruka',
        'Claims.Count': 'Pronađeni predmeti',
        'Claims.ThisWeek': 'Ovaj tjedan',
        'Claims.ThisMonth': 'Ovaj mjesec',
        'Claims.PreviousWeek': 'Prethodni tjedan',
        'Claims.PreviousMonth': 'Prethodni mjesec',
        'Claims.Criteria': 'Kriteriji',
        'Claims.CreatedDate': 'datum stvaranja',
        'Claims.ModifiedDate': 'datum izmijenjeni',
        'Claims.FilterAll': 'Sve',
        'AddressBook.FullName': 'Puno ime',
        'AddressBook.Organization': 'Organizacija',
        'AddressBook.Address': 'Adresa',
        'AddressBook.CaseTypes': 'Vrsta predmeta',
        'AddressBook.CreatedBy': 'Izradio',
        'AddressBook.Actions': 'Akcije',
        'AddressBook.CreateNew': 'Stvori novo',
        'AddressBookEdit.Organization': 'Organizacija',
        'AddressBookEdit.FirstName': 'Ime',
        'AddressBookEdit.LastName': 'Prezime',
        'AddressBookEdit.PhoneNumber': 'Telefonski broj',
        'AddressBookEdit.Email': 'E-pošta',
        'AddressBookEdit.Description': 'Opis',
        'AddressBookEdit.Street': 'Ulica',
        'AddressBookEdit.HouseNr': 'Kućni broj',
        'AddressBookEdit.City': 'Grad',
        'AddressBookEdit.PostalCode': 'Patent zatvarač',
        'AddressBookEdit.Country': 'Zemlja',
        'AddressBookEdit.CaseTypes': 'Vrste slučajeva',
        'AddressBookEdit.AdditionalInfo': 'Dodatne informacije',
        'AddressBookEdit.Visibility': 'Vidljivost',
        'AddressBookEdit.Visibility.Owner': 'Trebalo bi biti dostupno samo meni',
        'AddressBookEdit.Visibility.Organization': 'Trebalo bi biti dostupno u organizaciji',
        'AddressBookEdit.Save': 'Spremiti',
        'AddressBookEdit.Cancel': 'Otkazati',
        'AddressBookEdit.Title': 'Uređivanje adrese',
        'Settings.Ticket.Option.Header': 'Postavke ulaznica',
        'Settings.Ticket.Option.Field.Expires': 'Istječe',
        'Settings.Ticket.Option.Field.Reused': 'Može se ponovno upotrijebiti',
        'Settings.Ticket.SmsTemplate.Header': 'SMS predložak',
        'Settings.Ticket.SmsTemplate.Field.Template': 'SMS predložak',
        'Settings.Ticket.SmsTemplate.Field.AppendLinkButton': 'Dodaj vezu',
        'Settings.Ticket.EmailTemplate.Header': 'Predložak e-pošte',
        'Settings.Ticket.EmailTemplate.ReplyTo': 'Odgovor na',
        'Settings.Ticket.EmailTemplate.Field.Subject': 'Predmet',
        'Settings.Ticket.EmailTemplate.Error.EmailNotValid': 'Adresa e-pošte nije važeća',
        'OrganizationGroups.CreateNew': 'Stvori novo',
        'OrganizationGroups.Name': 'Ime',
        'OrganizationGroups.CaseTypes': 'Vrste slučajeva',
        'OrganizationGroups.Users': 'Korisnici',
        'OrganizationGroups.Actions': 'Akcije',
        'OrganizationGroups.Save': 'Spremiti',
        'OrganizationGroups.Cancel': 'Otkazati',
    }),
    'it': observable({
        'Field.Owner': 'Proprietario',
        'Field.Brand': 'Marca',
        'Field.Model': 'Modello',
        'Field.Mileage': 'Chilometraggio',
        'Field.LicensePlateNumber': 'Num. di targa',
        'Field.CarSerialNumber': 'Num. di serie',
        'Field.InsurancePolicyNumber': 'Num. di polizza assicurativa',
        'Field.ExternalID': 'ID esterno',
        'Claims.Organization': 'Organizzazione',
        'Claims.Expert': 'Esperto',
        'Claims.ExternalID': 'ID esterno',
        'Claims.Created': 'Creato',
        'Claims.LastChange': 'Ultima modifica',
        'Claims.CallDuration': 'Durata',
        'Claims.Photos': 'Fotografie',
        'Claims.Client': 'Cliente',
        'Claims.ClaimInfo': 'Informazioni',
        'Claims.Rating': 'Valutazione',
        'Claims.Actions': 'Azioni',
        'Claims.Today': 'Odierna',
        'Claims.Yesterday': 'Leri',
        'Claims.PageSize': 'Pagina',
        'Claims.Search': 'Ricerca',
        'Claims.FromDate': 'Dalla data',
        'Claims.ToDate': 'Fino data',
        'Claims.Country': 'Paese',
        'Claims.CaseType': 'Tipo di caso',
        'Claims.Text': 'Testo',
        'Claims.Count': 'сasi trovati',
        'Claims.ThisWeek': 'Settimana questa',
        'Claims.ThisMonth': 'Mese questa',
        'Claims.PreviousWeek': 'Settimana precedente',
        'Claims.PreviousMonth': 'Mese precedente',
        'Claims.Criteria': 'Criteri',
        'Claims.CreatedDate': 'Creato',
        'Claims.ModifiedDate': 'Ultima modifica',
        'Claims.FilterAll': 'Tutto',
        'AddressBook.FullName': 'Nome',
        'AddressBook.Organization': 'Organizzazione',
        'AddressBook.Address': 'Indirizzo',
        'AddressBook.CaseTypes': 'Tipi di casi',
        'AddressBook.CreatedBy': 'Creato da',
        'AddressBook.Actions': 'Azioni',
        'AddressBook.CreateNew': 'Add new address',
        'AddressBookEdit.Organization': 'Organization',
        'AddressBookEdit.FirstName': 'First Name',
        'AddressBookEdit.LastName': 'Last Name',
        'AddressBookEdit.PhoneNumber': 'Phone number',
        'AddressBookEdit.Email': 'Email',
        'AddressBookEdit.Description': 'Description',
        'AddressBookEdit.Street': 'Street',
        'AddressBookEdit.HouseNr': 'House Nr',
        'AddressBookEdit.City': 'City',
        'AddressBookEdit.PostalCode': 'Postal Code',
        'AddressBookEdit.Country': 'Country',
        'AddressBookEdit.CaseTypes': 'Case Types',
        'AddressBookEdit.AdditionalInfo': 'Additional Info',
        'AddressBookEdit.Visibility': 'Visibility',
        'AddressBookEdit.Visibility.Owner': 'Should be available only for me',
        'AddressBookEdit.Visibility.Organization': 'Should be available on organization',
        'AddressBookEdit.Save': 'Save',
        'AddressBookEdit.Cancel': 'Cancel',
        'AddressBookEdit.Title': 'Address',
        'Settings.Ticket.Option.Header': 'Ticket settings',
        'Settings.Ticket.Option.Field.Expires': 'Ticket expires',
        'Settings.Ticket.Option.Field.Reused': 'Ticket can be reused',
        'Settings.Ticket.SmsTemplate.Header': 'SMS template',
        'Settings.Ticket.SmsTemplate.Field.Template': 'SMS template',
        'Settings.Ticket.SmsTemplate.Field.AppendLinkButton': 'Append Link',
        'Settings.Ticket.EmailTemplate.Header': 'Email template',
        'Settings.Ticket.EmailTemplate.ReplyTo': 'Reply to',
        'Settings.Ticket.EmailTemplate.Field.Subject': 'Subject',
        'Settings.Ticket.EmailTemplate.Error.EmailNotValid': 'Email address is not valid',
        'OrganizationGroups.CreateNew': 'Create New',
        'OrganizationGroups.Name': 'Name',
        'OrganizationGroups.CaseTypes': 'Case Types',
        'OrganizationGroups.Users': 'Users',
        'OrganizationGroups.Actions': 'Actions',
        'OrganizationGroups.Save': 'Save',
        'OrganizationGroups.Cancel': 'Cancel',
    }),
    'fr': observable({
        'Field.Owner': 'Propriétaire',
        'Field.Brand': 'Marque',
        'Field.Model': 'Modèle',
        'Field.Mileage': 'Kilométrage',
        'Field.LicensePlateNumber': 'Numéro de plaque',
        'Field.CarSerialNumber': 'Numéro de série',
        'Field.InsurancePolicyNumber': 'Numéro de d\'assurance',
        'Field.ExternalID': 'ID externe',
        'Claims.Organization': 'Organisation',
        'Claims.Expert': 'Expert',
        'Claims.ExternalID': 'ID externe',
        'Claims.Created': 'Établi',
        'Claims.LastChange': 'Dernier changement',
        'Claims.CallDuration': 'Durée d\'appel',
        'Claims.Photos': 'Photos',
        'Claims.Client': 'Client',
        'Claims.ClaimInfo': 'Informations',
        'Claims.Rating': 'Évaluation',
        'Claims.Actions': 'Actions',
        'Claims.Today': 'Aujourd\'hui',
        'Claims.Yesterday': 'Hier',
        'Claims.PageSize': 'Taille de la page',
        'Claims.Search': 'Chercher',
        'Claims.FromDate': 'Partir de la date',
        'Claims.ToDate': 'À ce jour',
        'Claims.Country': 'Pays',
        'Claims.CaseType': 'Type de boîtier',
        'Claims.Text': 'Texte',
        'Claims.Count': 'cas trouvé',
        'Claims.ThisWeek': 'Cette semaine',
        'Claims.ThisMonth': 'Ce mois-ci',
        'Claims.PreviousWeek': 'La semaine précédente',
        'Claims.PreviousMonth': 'Le mois précédent',
        'Claims.Criteria': 'Critère',
        'Claims.CreatedDate': 'Date de création',
        'Claims.ModifiedDate': 'Date modifiée',
        'Claims.FilterAll': 'Toute',
        'AddressBook.FullName': 'Nom',
        'AddressBook.Organization': 'Organisation',
        'AddressBook.Address': 'Adresse',
        'AddressBook.CaseTypes': 'Types de boîtier',
        'AddressBook.CreatedBy': 'Créé par',
        'AddressBook.Actions': 'Actions',
        'AddressBook.CreateNew': 'Add new address',
        'AddressBookEdit.Organization': 'Organization',
        'AddressBookEdit.FirstName': 'First Name',
        'AddressBookEdit.LastName': 'Last Name',
        'AddressBookEdit.PhoneNumber': 'Phone number',
        'AddressBookEdit.Email': 'Email',
        'AddressBookEdit.Description': 'Description',
        'AddressBookEdit.Street': 'Street',
        'AddressBookEdit.HouseNr': 'House Nr',
        'AddressBookEdit.City': 'City',
        'AddressBookEdit.PostalCode': 'Postal Code',
        'AddressBookEdit.Country': 'Country',
        'AddressBookEdit.CaseTypes': 'Case Types',
        'AddressBookEdit.AdditionalInfo': 'Additional Info',
        'AddressBookEdit.Visibility': 'Visibility',
        'AddressBookEdit.Visibility.Owner': 'Should be available only for me',
        'AddressBookEdit.Visibility.Organization': 'Should be available on organization',
        'AddressBookEdit.Save': 'Save',
        'AddressBookEdit.Cancel': 'Cancel',
        'AddressBookEdit.Title': 'Address',
        'Settings.Ticket.Option.Header': 'Ticket settings',
        'Settings.Ticket.Option.Field.Expires': 'Ticket expires',
        'Settings.Ticket.Option.Field.Reused': 'Ticket can be reused',
        'Settings.Ticket.SmsTemplate.Header': 'SMS template',
        'Settings.Ticket.SmsTemplate.Field.Template': 'SMS template',
        'Settings.Ticket.SmsTemplate.Field.AppendLinkButton': 'Append Link',
        'Settings.Ticket.EmailTemplate.Header': 'Email template',
        'Settings.Ticket.EmailTemplate.ReplyTo': 'Reply to',
        'Settings.Ticket.EmailTemplate.Field.Subject': 'Subject',
        'Settings.Ticket.EmailTemplate.Error.EmailNotValid': 'Email address is not valid',
        'OrganizationGroups.CreateNew': 'Create New',
        'OrganizationGroups.Name': 'Name',
        'OrganizationGroups.CaseTypes': 'Case Types',
        'OrganizationGroups.Users': 'Users',
        'OrganizationGroups.Actions': 'Actions',
        'OrganizationGroups.Save': 'Save',
        'OrganizationGroups.Cancel': 'Cancel',
    })
};
var LanguageStore = /** @class */ (function () {
    function LanguageStore() {
        Object.defineProperty(this, "translations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: translations
        });
        Object.defineProperty(this, "currentLanguage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.getPageLanguage()
        });
        makeObservable(this);
        window.$LanguageStore = this;
    }
    Object.defineProperty(LanguageStore.prototype, "setTranslations", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (translations) {
            this.translations = {};
            for (var lang in translations) {
                if (translations.hasOwnProperty(lang)) {
                    var values = translations[lang];
                    this.translations[lang] = observable(values);
                }
            }
        }
    });
    Object.defineProperty(LanguageStore.prototype, "updateKey", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (key, newKey) {
            for (var _i = 0, _a = this.getLanguages(); _i < _a.length; _i++) {
                var lang = _a[_i];
                var langTranslations = this.translations[lang];
                if (langTranslations && langTranslations.hasOwnProperty(key)) {
                    var label = langTranslations[key];
                    delete langTranslations[key];
                    langTranslations[newKey] = label;
                }
            }
        }
    });
    Object.defineProperty(LanguageStore.prototype, "updateLabel", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (key, language, label) {
            this.translations[language][key] = label;
        }
    });
    Object.defineProperty(LanguageStore.prototype, "addLabel", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (key, language) {
            if (this.translations[language][key])
                return;
            this.translations[language][key] = '';
        }
    });
    Object.defineProperty(LanguageStore.prototype, "removeLabel", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (key) {
            for (var _i = 0, _a = this.getLanguages(); _i < _a.length; _i++) {
                var lang = _a[_i];
                var langTranslations = this.translations[lang];
                if (langTranslations && langTranslations.hasOwnProperty(key))
                    delete langTranslations[key];
            }
        }
    });
    Object.defineProperty(LanguageStore.prototype, "setCurrentLanguage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (language) {
            this.currentLanguage = language;
        }
    });
    Object.defineProperty(LanguageStore.prototype, "getLanguages", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return Object.keys(this.translations);
        }
    });
    Object.defineProperty(LanguageStore.prototype, "getKeys", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var keys = [];
            for (var _i = 0, _a = this.getLanguages(); _i < _a.length; _i++) {
                var lang = _a[_i];
                var langEntries = this.translations[lang];
                for (var key in langEntries) {
                    if (keys.indexOf(key) === -1) {
                        keys.push(key);
                    }
                }
            }
            return _.sortBy(keys);
        }
    });
    Object.defineProperty(LanguageStore.prototype, "getLabelForField", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (field) {
            return this.getLabel(field === null || field === void 0 ? void 0 : field.name, field === null || field === void 0 ? void 0 : field.defaultLabel);
        }
    });
    Object.defineProperty(LanguageStore.prototype, "getLabel", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (key, defaultLabel, language) {
            if (!key)
                return defaultLabel !== null && defaultLabel !== void 0 ? defaultLabel : key;
            if (defaultLabel)
                return defaultLabel;
            var lang = this.translations[language !== null && language !== void 0 ? language : this.currentLanguage];
            if (!lang)
                return key;
            var translation = lang[key];
            return translation !== null && translation !== void 0 ? translation : key;
        }
    });
    Object.defineProperty(LanguageStore.prototype, "getMuiLocale", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var pageLanguage = this.getPageLanguage();
            return localeMap[pageLanguage];
        }
    });
    Object.defineProperty(LanguageStore.prototype, "getPageLanguage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var language = document.documentElement.lang;
            if (!this.translations[language])
                language = 'en';
            return language;
        }
    });
    __decorate([
        observable
    ], LanguageStore.prototype, "translations", void 0);
    __decorate([
        observable
    ], LanguageStore.prototype, "currentLanguage", void 0);
    __decorate([
        action
    ], LanguageStore.prototype, "setTranslations", null);
    __decorate([
        action
    ], LanguageStore.prototype, "updateKey", null);
    __decorate([
        action
    ], LanguageStore.prototype, "updateLabel", null);
    __decorate([
        action
    ], LanguageStore.prototype, "addLabel", null);
    __decorate([
        action
    ], LanguageStore.prototype, "removeLabel", null);
    __decorate([
        action
    ], LanguageStore.prototype, "setCurrentLanguage", null);
    return LanguageStore;
}());
export default LanguageStore;
